// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CostaRica from '../_raw/flag/icon_flag_costa_rica.png';

export default () => <img src={CostaRica} alt="CostaRica" />;
